import { render, staticRenderFns } from "./crmUserManageList.vue?vue&type=template&id=2db5d716&scoped=true"
import script from "./crmUserManageList.vue?vue&type=script&lang=js"
export * from "./crmUserManageList.vue?vue&type=script&lang=js"
import style0 from "./crmUserManageList.vue?vue&type=style&index=0&id=2db5d716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5d716",
  null
  
)

export default component.exports